import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { TeamModel } from 'projects/core/src/lib/models/team.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss']
})
export class TeamListComponent extends BaseList implements OnInit {

  public teams: Array<TeamModel> = [];
  public apiUrl = '/teams';

  protected rightLoad = 'admin.team.list';
  protected rightNew = 'admin.team.create';
  protected rightOpen = 'admin.team.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.teams'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('teams').subscribe({
      next: (teams: any) => {
        this.teams = [];
        teams.data.forEach((team: any) => {
          this.teams.push(new TeamModel().deserialize(team));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
